import { render, staticRenderFns } from "./UnitWorkUnitsList.vue?vue&type=template&id=4a6da3e9&scoped=true"
import script from "./UnitWorkUnitsList.vue?vue&type=script&lang=js"
export * from "./UnitWorkUnitsList.vue?vue&type=script&lang=js"
import style0 from "./UnitWorkUnitsList.vue?vue&type=style&index=0&id=4a6da3e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6da3e9",
  null
  
)

export default component.exports